module.exports = __webpack_public_path__ + "static/product_commander-bbd700b52134c7d1afae3f5000e76aa7.png";